export const GiraffeTable = () => (
  <svg width="544" height="692" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clipYugiTable)">
      <path
        d="M90.293 583.929s-10.626-30.173-7.446-60.734c3.18-30.561 14.04-62.596-13.109-75.782"
        stroke="#2EAF71"
        strokeWidth="1.551"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.847 536.226s24.743-36.999 43.204-14.272c18.46 22.726 6.438 61.975 6.438 61.975"
        stroke="#2EAF71"
        strokeWidth="1.551"
        strokeMiterlimit="10"
      />
      <path
        d="M123.57 458.97s5.817 38.938 1.396 67.56c-4.499 28.544-18.306 38.628-24.356 53.288"
        stroke="#2EAF71"
        strokeWidth="1.551"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.749 469.364s51.348-.077 41.11 114.565c-1.474 16.676 15.048-37.31 17.84-72.369 2.792-35.06 36.844-36.378 36.844-36.378"
        stroke="#2EAF71"
        strokeWidth="1.551"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M188.647 461.297s-9.696 30.251-31.802 16.211c-22.106-14.039 14.117-26.837 31.802-16.211z"
        fill="#0FE885"
      />
      <path
        d="M188.648 461.297s-15.513.078-28.079 9.541"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.542 466.882s-.31-21.641-26.838-10.704L27 461.685s7.524 2.482 22.494 13.186c15.048 10.782 14.505-2.172 15.048-7.989z"
        fill="#0FE885"
      />
      <path
        d="M60.975 466.106s-10.55-13.574-30.329-4.266"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.904 524.591s18.151-2.327 19.081 7.213c.854 9.541-2.869 16.134-14.427 32.888-.077 0-39.558-32.888-4.654-40.101z"
        fill="#0FE885"
      />
      <path
        d="M131.945 561.435s2.172-23.658-4.731-35.06"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.694 528.702s-6.749-17.53-28.777-3.025c-22.029 14.505 8.222 43.514 8.222 43.514s7.136-38.783 20.555-40.489z"
        fill="#0FE885"
      />
      <path
        d="M60.895 521.1s-18.384 5.663-7.757 48.091"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.205 589.436s21.718-74.851 14.272-103.628"
        stroke="#2EAF71"
        strokeWidth="1.551"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M135.281 460.211s-4.033-3.723-14.117 12.411c-10.083 16.134-8.377 16.134-8.377 16.134s-23.658-22.805-6.36-39.559c0 .078 12.72-8.299 28.854 11.014z"
        fill="#0FE885"
      />
      <path
        d="M111.313 482.473c-5.274-22.339-.232-28.002-.232-28.002"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.328 429.728s.93 28.389 28.156 22.572c0 0 27.691-20.865-28.156-22.572z"
        fill="#0FE885"
      />
      <path
        d="M76.098 450.516s-16.289-18.694-27.846-20.788"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M64.307 692.055h62.363l18.461-112.315H45.847l18.46 112.315z" fill="#FFD600" />
      <path d="M145.132 579.74H120l-17.142 112.315h23.813l18.461-112.315z" fill="#E8BD0A" />
      <g
        opacity=".53"
        stroke="#E8BD0A"
        strokeWidth=".582"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          opacity=".53"
          d="M61.748 667.467s9.463-7.524 4.809-12.1c-5.662-2.327-4.81 12.1-4.81 12.1zM63.377 668.941s11.48 3.8 12.798-2.638c-1.24-5.972-12.798 2.638-12.798 2.638zM62.445 671.112s2.482 11.868 8.688 9.696c4.654-4.033-8.688-9.696-8.688-9.696z"
        />
      </g>
      <g
        opacity=".53"
        stroke="#E8BD0A"
        strokeWidth=".582"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          opacity=".53"
          d="M72.997 611.154s7.446-12.953 0-16.133c-7.602 0 0 16.133 0 16.133zM72.918 615.808s-7.446 12.954 0 16.134c7.524 0 0-16.134 0-16.134zM70.747 614.567s-14.893.853-13.496 8.842c4.11 6.283 13.496-8.842 13.496-8.842zM75.478 612.085s14.893-.853 13.497-8.842c-4.189-6.283-13.496 8.842-13.496 8.842zM70.048 612.085s-8.3-12.41-14.427-7.214c-3.335 6.826 14.427 7.214 14.427 7.214zM75.478 615.033s8.3 12.41 14.428 7.213c3.335-6.826-14.428-7.213-14.428-7.213z"
        />
      </g>
      <g opacity=".51" stroke="#FFD600" strokeWidth=".582" strokeMiterlimit="10">
        <path
          opacity=".51"
          d="M114.723 644.43s6.67-11.558 0-14.427c-6.748 0 0 14.427 0 14.427zM114.646 648.618s-6.67 11.558 0 14.427c6.749-.077 0-14.427 0-14.427zM112.705 647.455s-13.341.775-12.022 7.834c3.645 5.74 12.022-7.834 12.022-7.834zM116.972 645.283s13.341-.776 12.022-7.834c-3.723-5.662-12.022 7.834-12.022 7.834zM112.163 645.283s-7.369-11.092-12.876-6.438c-3.025 6.05 12.876 6.438 12.876 6.438zM116.972 647.843s7.368 11.091 12.876 6.437c3.025-6.05-12.876-6.437-12.876-6.437z"
        />
      </g>
      <path
        d="M120.001 591.142h-71.36M113.096 591.142L98.203 692.055"
        stroke="#E8BD0A"
        strokeWidth="1.551"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity=".51" stroke="#FFD600" strokeWidth=".582" strokeMiterlimit="10">
        <path
          opacity=".51"
          d="M132.1 580.904s4.188 8.222 8.377 5.429c2.559-3.878-8.377-5.429-8.377-5.429zM130.781 581.912s-4.576 8.067 0 10.006c4.732-.078 0-10.006 0-10.006zM129.307 580.904s-9.231.077-8.61 5.041c2.327 4.034 8.61-5.041 8.61-5.041z"
        />
      </g>
      <path
        d="M95.335 569.501s1.551-15.358-27.07-12.798c0 0-15.359.853-9.929 30.328 0 0 29.475-22.261 36.999-17.53z"
        fill="#0FE885"
      />
      <path
        d="M59.19 584.006s-.233-22.261 22.26-27.07"
        stroke="#74F7B8"
        strokeWidth=".776"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity=".51"
        d="M157.666 495.831l-15.591-121.313 45.609-27.303 178.013 148.771-208.031-.155z"
        fill="#fff"
      />
      <path
        d="M152.426 331.449l-4.979-4.203-61.146 72.426 4.979 4.203 61.146-72.426z"
        fill="#CEB2C4"
      />
      <path
        d="M89.563 399.494a3.278 3.278 0 013.258 3.258v87.417a3.277 3.277 0 01-3.258 3.257 3.277 3.277 0 01-3.257-3.257v-87.417a3.278 3.278 0 013.257-3.258z"
        fill="#CEB2C4"
      />
      <path d="M90.572 408.027a6.749 6.749 0 100-13.498 6.749 6.749 0 000 13.498z" fill="#BA90A9" />
      <path
        d="M153.4 329.685l-8.998 5.663c-1.629 1.008-3.723.543-4.809-1.086l-2.792-4.499c-2.56-4.111-1.319-9.541 2.792-12.1 4.111-2.56 9.54-1.319 12.1 2.792l2.793 4.499c1.008 1.629.542 3.723-1.086 4.731z"
        fill="#CEB2C4"
      />
      <path
        d="M187.682 347.215l-45.609 27.303-8.532-42.118 22.029-13.186 32.112 28.001zM111.204 495.831H67.922a3.476 3.476 0 01-3.49-3.491 3.476 3.476 0 013.49-3.49h43.282a3.475 3.475 0 013.49 3.49 3.476 3.476 0 01-3.49 3.491z"
        fill="#BA90A9"
      />
      <path
        d="M520.287 692.149l13.419.156-23.657-183.753-13.419 1.473 23.657 182.124zM423.251 507.776l-13.419-1.474-23.657 183.753 13.574.078 23.502-182.357z"
        fill="#D37AB5"
      />
      <path
        d="M164.88 512.74h376.116v-16.754H164.88v16.754zM173.102 540.741h351.915v-27.535H173.102v27.535z"
        fill="#D37AB5"
      />
      <path
        d="M273.627 530.115h-16.909c-2.094 0-3.878-1.707-3.878-3.879 0-2.094 1.706-3.878 3.878-3.878h16.909c2.095 0 3.879 1.707 3.879 3.878 0 2.095-1.707 3.879-3.879 3.879zM462.191 530.115h-16.909c-2.095 0-3.879-1.707-3.879-3.879 0-2.094 1.707-3.878 3.879-3.878h16.909c2.094 0 3.878 1.707 3.878 3.878-.077 2.095-1.784 3.879-3.878 3.879z"
        fill="#BC68A4"
      />
      <path
        d="M171.628 692.072l13.652.233-23.658-183.753-13.419 1.473 23.425 182.047zM74.826 507.776l-13.418-1.474L37.75 690.055l13.574.233 23.502-182.512z"
        fill="#F7B7D6"
      />
      <path
        d="M30.148 512.74h136.515v-16.754H30.147v16.754zM47.059 540.741h127.75v-27.535H47.059v27.535z"
        fill="#F7B7D6"
      />
      <path d="M30.148 512.74h510.847" stroke="#AF588E" strokeWidth=".776" strokeMiterlimit="10" />
      <path d="M236.782 489.471h-63.759l-13.961-57.011h62.828l14.892 57.011z" fill="#AB95F9" />
      <path d="M159.062 432.46l-3.025 1.241 15.591 62.518h3.18l-15.746-63.759z" fill="#C7B4FD" />
      <path d="M163.717 435.64h55.847l14.272 53.83h-57.088l-13.031-53.83z" fill="#E4FCF4" />
      <g opacity=".46">
        <path
          opacity=".46"
          d="M202.112 456.35c1.629 7.058-2.947 12.798-10.161 12.488-6.36-.31-12.721-5.585-14.427-11.945-1.862-7.136 2.482-12.954 9.385-12.954l2.793 12.333h12.41v.078z"
          fill="#00ED9D"
        />
        <path
          opacity=".46"
          d="M203.974 454.256h-12.333l-2.792-12.333c6.825 0 13.574 5.507 15.125 12.333z"
          fill="#80F6CD"
        />
      </g>
      <path
        opacity=".46"
        d="M224.918 482.645h-26.916c-.775 0-1.629-.698-1.861-1.474l-1.552-5.662c-.232-.776.233-1.474 1.009-1.474h26.527c.776 0 1.629.62 1.862 1.474l1.784 5.662c.31.853-.078 1.474-.853 1.474z"
        fill="#80F6CD"
      />
      <g opacity=".28" fill="#fff">
        <path
          opacity=".28"
          d="M206.144 432.46l-19.469 57.011h9.773l18.771-57.011h-9.075zM201.411 432.46l-18.77 57.011h2.637l18.848-57.011h-2.715z"
        />
      </g>
      <path
        d="M379.812 512.74s-36.766 38.938 6.36 75.394l-27.846 8.61s-39.403-29.553-16.056-79.272l37.542-4.732z"
        fill="#EFC700"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M379.113 582.859l-19.935 12.178c-1.396.853-1.861 2.715-1.086 4.266l7.447 14.505c1.086 2.094 3.8 2.715 5.352 1.164l20.787-19.702c1.397-1.319 1.241-3.723-.387-5.042l-8.222-6.981a3.279 3.279 0 00-3.956-.388z"
        fill="#B77B02"
      />
      <path
        d="M435.196 559.59h-62.285c-1.629 0-3.025-1.784-3.025-3.878 0-2.172 1.396-3.879 3.025-3.879h62.285c1.629 0 3.025 1.784 3.025 3.879-.077 2.094-1.396 3.878-3.025 3.878z"
        fill="#848484"
      />
      <path
        d="M370.273 555.556h67.947c4.809 0 8.765-3.878 8.765-8.764 0-4.887-3.878-8.765-8.765-8.765h-67.947c-4.809 0-8.765 3.878-8.765 8.765 0 4.886 4.033 8.764 8.765 8.764z"
        fill="#AB95F9"
      />
      <path
        d="M408.823 670.431c0 2.172-1.474 4.111-3.646 4.576h-.155l-30.483 7.059-6.283 1.474c-.853.155-1.784.155-2.482-.078-1.474-.465-2.715-1.784-3.103-3.335-.077-.388-.077-.776-.077-1.009 0-2.171 1.474-4.111 3.645-4.576l36.922-8.532a4.1 4.1 0 011.939 0c1.784.388 3.257 1.706 3.645 3.49.078.311.078.543.078.931z"
        fill="#848484"
      />
      <path
        d="M447.449 678.963c0 .388 0 .776-.077 1.009-.31 1.241-1.009 2.249-1.939 2.87-1.009.62-2.327.93-3.646.62l-5.197-1.241-31.491-7.214h-.156c-2.171-.465-3.645-2.404-3.645-4.576 0-.388 0-.62.077-1.008.388-1.862 1.862-3.18 3.646-3.491a8.167 8.167 0 011.939 0l36.844 8.532c2.172.388 3.645 2.405 3.645 4.499z"
        fill="#848484"
      />
      <path
        d="M407.892 673.766h-4.111c-2.249 0-4.033-1.784-4.033-3.955V568.277c0-2.249 1.784-3.956 4.033-3.956h4.111c2.25 0 4.034 1.784 4.034 3.956v101.378c0 2.25-1.862 4.111-4.034 4.111z"
        fill="#848484"
      />
      <path
        d="M414.562 559.59h-17.453v44.755h17.453V559.59zM414.562 625.986a2.417 2.417 0 00-2.404-2.405h-12.566a2.416 2.416 0 00-2.404 2.405 2.415 2.415 0 002.404 2.404h12.566a2.416 2.416 0 002.404-2.404zM414.562 640.181a2.417 2.417 0 00-2.404-2.405h-12.566a2.416 2.416 0 00-2.404 2.405 2.416 2.416 0 002.404 2.404h12.566a2.417 2.417 0 002.404-2.404zM414.562 654.065a2.417 2.417 0 00-2.404-2.405h-12.566a2.416 2.416 0 00-2.404 2.405 2.416 2.416 0 002.404 2.404h12.566c1.318.078 2.404-1.086 2.404-2.404z"
        fill="#848484"
      />
      <path
        d="M441.4 690.521a6.826 6.826 0 100-13.652 6.826 6.826 0 000 13.652zM368.022 690.521a6.826 6.826 0 100-13.652 6.826 6.826 0 000 13.652z"
        fill="#AB95F9"
      />
      <path
        d="M311.554 175.252s24.278 209.35 3.878 234.946c-22.261 27.924-39.636 59.726 10.316 46.85l4.654 53.52s-24.123 36.456 58.174 29.475l14.815-2.559c14.971-5.43 30.716-14.66 33.043-26.838.078-.466 1.086-3.878 1.086-7.679.543-24.511-53.83-139.386-53.83-139.386-7.834-16.599-32.267-231.843-32.267-231.843l-44.833 5.972 4.964 37.542z"
        fill="#FFDC04"
      />
      <path
        d="M332.109 64.721c-.543-1.629-1.784-3.025-3.413-3.568l-2.017-.776a5.856 5.856 0 00-4.964.388c-1.474.931-2.482 2.405-2.715 4.189l-.31 2.792c-.078.388-.155.698-.388 1.086l-.543.853c-.698 1.164-1.396 2.405-1.939 3.724l-2.87 9.385-7.058-6.516-.078-.155c-1.086-.93-2.249-1.629-3.568-2.327l-.853-.465a2.006 2.006 0 01-.853-.776l-1.629-2.172c-1.086-1.396-2.638-2.249-4.422-2.249-1.706 0-3.412.776-4.498 2.172l-1.319 1.706c-1.086 1.319-1.474 3.103-1.086 4.81a5.594 5.594 0 003.103 3.878l2.559 1.163c.388.155.621.31.931.698l.621.698c.931 1.086 1.861 2.095 3.025 3.025l7.601 4.965c2.948 1.939 5.042 5.041 6.361 9.463.387 1.318 1.086 4.111 1.086 4.111l2.171 8.299 11.945-3.258-2.482-8.144s-.698-2.792-1.086-4.111c-1.085-4.499-.853-8.144.776-11.325l3.956-7.989v-.233c.465-1.318.776-2.714 1.086-4.11l.155-1.009c.078-.388.233-.698.465-1.008l1.552-2.25c1.008-1.551 1.241-3.335.698-4.964z"
        fill="#724010"
      />
      <path
        d="M363.059 82.173c-6.128.931-12.333 3.025-16.599 7.602-3.491 3.8-6.438 8.144-7.757 13.108-1.629 5.973-2.948 11.945-3.956 21.486 0 0 7.059 2.637 6.671 4.499 7.911-.853 20.399-1.707 26.217-6.516 6.128-5.119 8.687-10.393 10.549-18.228 1.939-7.756 1.163-15.978 2.482-23.89-5.895.543-12.411 1.319-17.607 1.94z"
        fill="#FFDC04"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M329.239 101.177c4.034-1.319 8.3-1.164 12.178.698.388.155.62.31.931.465 4.033 2.56 6.981 5.663 7.524 11.015l6.515 65.31-44.367 4.421-14.815 1.474c-.078 0-.621.078-.699.078-15.668 1.551-30.638-7.214-36.921-21.564-.077-.155-.077-.232-.155-.31 0-.077-.077-.155-.077-.233-5.74-15.435 6.748-30.095 20.244-38.705 6.283-4.266 23.735-12.643 35.525-18.073.698-.31 1.241-.62 2.017-.775l12.1-3.801z"
        fill="#FFDC04"
      />
      <path
        d="M309.848 131.272c1.629-1.008 3.568-1.473 5.43-.93 1.629.543 2.87 1.551 3.801 2.87.853 1.396 2.947 1.085 3.18-.543v-.078c.31-3.258-1.474-6.438-4.266-7.989-4.809-2.637-10.549-.233-12.178 4.809-.233.698-.388 1.396-.388 2.094-.077 1.629 1.784 2.482 2.948 1.241.31-.62.853-1.086 1.473-1.474z"
        fill="#37393B"
      />
      <path
        d="M312.562 182.854s18.849-1.164 29.708-8.843c0 0-5.895 18.461-28.389 21.176-.077-.078-1.319-12.333-1.319-12.333z"
        fill="#E5C501"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M327.999 255.688c-.699 3.878-4.344 6.36-8.222 5.662h-.233c-.31-4.576-.698-9.153-1.086-13.497a6.827 6.827 0 013.723-.31c4.034.698 6.516 4.421 5.818 8.145zM368.487 404.691l-15.435 2.095c-1.474.232-2.715-.776-2.87-2.172l-2.172-15.436c-.62-4.809 2.405-9.618 7.214-10.626 5.352-1.086 10.316 2.482 10.936 7.756 5.275-.775 10.084 3.103 10.549 8.455.388 4.964-3.413 9.23-8.222 9.928zM360.576 275.389c-.465 2.405-2.792 3.956-5.197 3.568-2.404-.465-3.956-2.792-3.568-5.197.466-2.404 2.793-3.955 5.197-3.568 2.327.466 3.956 2.793 3.568 5.197zM380.278 349.775c-.931 1.706-2.715 2.637-4.731 2.327-2.482-.466-3.956-2.793-3.568-5.197.387-2.405 2.792-3.956 5.196-3.568.776.155 1.552.465 2.172 1.008.233 1.939.621 3.723.931 5.43zM367.789 310.759c-.62 3.18-3.645 5.352-6.903 4.732-3.258-.621-5.275-3.646-4.654-6.904.621-3.18 3.646-5.352 6.826-4.809 3.102.621 5.352 3.646 4.731 6.981zM345.371 333.564c-.62 3.18-3.645 5.352-6.903 4.731a5.862 5.862 0 01-4.654-6.903c.621-3.181 3.646-5.352 6.826-4.809 3.18.698 5.274 3.8 4.731 6.981zM365.23 245.604c-1.086.543-2.482.698-3.801.466-3.568-.621-5.972-4.111-5.352-7.757.621-3.568 3.956-5.895 7.524-5.352.465 4.266 1.086 8.455 1.629 12.643zM333.738 298.349c-.853 4.731-5.429 7.911-10.238 7.058-.388-.077-.776-.155-1.164-.31a567.981 567.981 0 00-.931-16.211 9.166 9.166 0 015.275-.698c4.731.853 7.911 5.429 7.058 10.161zM380.432 423.152c-1.629 2.172-4.809 2.637-6.903 1.008-2.172-1.629-2.638-4.809-1.009-6.903 1.629-2.172 4.809-2.637 6.904-1.008 2.327 1.628 2.792 4.653 1.008 6.903zM418.129 452.317c-1.629 2.171-4.809 2.637-6.903 1.008-2.172-1.629-2.637-4.809-1.009-6.903 1.629-2.172 4.81-2.638 6.904-1.009 2.249 1.629 2.637 4.732 1.008 6.904zM395.557 451.308c-2.87 3.878-8.455 4.576-12.255 1.629-3.879-2.947-4.577-8.455-1.629-12.255 2.947-3.879 8.454-4.577 12.333-1.707 3.645 3.025 4.421 8.455 1.551 12.333z"
        fill="#C6880D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M338.392 338.295a5.862 5.862 0 01-4.654-6.903c.62-3.18 3.645-5.352 6.826-4.809 3.18.62 5.352 3.645 4.731 6.903-.543 3.335-3.645 5.43-6.903 4.809zm16.987-59.338c-2.405-.465-3.956-2.792-3.568-5.197.465-2.404 2.792-3.955 5.197-3.568 2.404.466 3.955 2.793 3.568 5.197-.466 2.405-2.793 4.034-5.197 3.568zm.698 29.63c.62-3.18 3.645-5.352 6.826-4.809 3.18.621 5.352 3.646 4.731 6.904-.62 3.18-3.646 5.352-6.903 4.731-3.258-.543-5.275-3.645-4.654-6.826zm12.41 96.104l-15.435 2.095c-1.474.232-2.715-.776-2.87-2.172l-2.172-15.436c-.621-4.809 2.404-9.618 7.214-10.626 5.352-1.086 10.316 2.482 10.936 7.756 5.275-.775 10.084 3.103 10.549 8.455.388 4.964-3.413 9.23-8.222 9.928zm11.945 18.461c-1.629 2.172-4.809 2.637-6.903 1.008-2.172-1.629-2.637-4.809-1.008-6.903 1.629-2.172 4.809-2.637 6.903-1.009 2.327 1.629 2.792 4.654 1.008 6.904zm15.126 28.156c-2.87 3.878-8.455 4.577-12.256 1.629-3.8-2.947-4.576-8.455-1.629-12.255 2.948-3.879 8.455-4.577 12.333-1.707 3.646 3.025 4.422 8.455 1.552 12.333zm22.571 1.009c-1.629 2.171-4.809 2.637-6.903 1.008-2.172-1.629-2.637-4.809-1.008-6.903 1.628-2.172 4.809-2.638 6.903-1.009 2.249 1.629 2.637 4.732 1.008 6.904zM410.139 422.919s0 .078-.155.078c-2.948 3.878-8.455 4.576-12.256 1.629-3.878-2.948-4.576-8.455-1.628-12.256 1.939-2.637 4.964-3.8 7.989-3.413 2.094 4.577 4.033 9.231 6.05 13.962zM397.575 393.987c-.156.155-.311.466-.388.621-2.017 2.559-5.74 3.18-8.3 1.163-2.637-2.017-3.18-5.662-1.163-8.299 1.473-1.862 3.8-2.715 5.972-2.172 1.164 2.637 2.482 5.507 3.879 8.687z"
        fill="#C6880D"
      />
      <path
        d="M332.109 64.721c-.543-1.629-1.784-3.025-3.413-3.568l-2.017-.776a5.856 5.856 0 00-4.964.388c-1.474.931-2.482 2.405-2.715 4.189l-.31 2.792c-.078.388-.155.698-.388 1.086l-.543.853c-.698 1.164-1.396 2.405-1.939 3.724l-2.87 9.385-7.058-6.516-.078-.155c-1.086-.93-2.249-1.629-3.568-2.327l-.853-.465a2.006 2.006 0 01-.853-.776l-1.629-2.172c-1.086-1.396-2.638-2.249-4.422-2.249-1.706 0-3.412.776-4.498 2.172l-1.319 1.706c-1.086 1.319-1.474 3.103-1.086 4.81a5.594 5.594 0 003.103 3.878l2.559 1.163c.388.155.621.31.931.698l.621.698c.931 1.086 1.861 2.095 3.025 3.025l7.601 4.965c2.948 1.939 5.042 5.041 6.361 9.463.387 1.318 1.086 4.111 1.086 4.111l.465 1.939 3.025-1.319 8.61-2.792-.311-1.009s-.698-2.792-1.085-4.11c-1.086-4.5-.854-8.145.775-11.325l3.956-7.99v-.232c.465-1.319.776-2.715 1.086-4.111l.155-1.008c.078-.388.233-.699.466-1.009l1.551-2.25c.853-1.473 1.086-3.257.543-4.886z"
        fill="#724010"
      />
      <path
        d="M325.749 457.436c-17.84 22.106-63.138 31.879-95.561 31.026-2.016-8.92-.465-19.391 1.396-26.527 37.852-7.369 69.81-22.882 88.736-64.612"
        fill="#FFDC04"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M234.454 488.152c.543-8.3 1.241-17.065 1.473-25.364.078-2.327-.775-3.258-3.025-3.801-5.197-1.163-11.247-2.404-16.521-3.025-2.948-.388-4.577.853-4.189 3.878 1.164 10.162 2.793 20.866 4.422 30.949.465 2.715 2.016 3.413 4.576 3.103 3.335-.466 7.291-1.474 10.549-2.482 1.784-.543 2.56-1.319 2.715-3.258z"
        fill="#C6880D"
      />
      <path
        d="M437.366 500.174c2.172 21.176-10.083 33.431-29.94 38.163-3.956.931-21.331 4.731-41.886 9.618-29.397 9.54-42.506 30.716-59.725 69.499a4239.705 4239.705 0 00-33.276-12.256c11.014-36.068 29.165-70.507 58.019-95.328"
        fill="#FFDC04"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M304.729 612.102c-9.541-3.801-19.702-7.679-29.32-11.092-2.715-.931-4.189-.31-5.585 2.094-3.18 5.662-6.825 12.178-9.308 18.073-1.473 3.413-.62 5.662 3.181 6.438 12.255 2.482 25.596 4.499 38.007 6.36 3.335.466 4.731-1.008 5.197-4.188.62-4.111.698-9.153.698-13.342 0-2.249-.543-3.412-2.87-4.343z"
        fill="#C78800"
      />
      <path
        d="M432.014 512.74s6.438 39.791 36.533 46.927"
        stroke="#FFDC04"
        strokeWidth="10.859"
        strokeMiterlimit="10"
      />
      <path
        d="M465.755 564.942s11.014 15.358 15.358 12.41c4.344-2.947-2.637-9.928-2.637-9.928s13.884 9.696 16.987 4.188c3.102-5.507-12.954-11.479-12.954-11.479s10.937-1.164 8.998-6.438c-1.939-5.275-22.494.155-22.494.155l-3.258 11.092z"
        fill="#C78800"
      />
      <path
        d="M432.789 488.772h-19.003c-7.757 0-14.04-6.282-14.04-14.039v-28.699c0-7.757 6.283-14.04 14.04-14.04h19.003c7.757 0 14.039 6.283 14.039 14.04v28.699c0 7.757-6.282 14.039-14.039 14.039z"
        fill="#AB95F9"
      />
      <path
        d="M426.197 559.59h-2.482a3.642 3.642 0 01-3.646-3.646v-77.488a3.641 3.641 0 013.646-3.645h2.482a3.641 3.641 0 013.646 3.645v77.488c-.078 2.017-1.629 3.646-3.646 3.646z"
        fill="#848484"
      />
      <path d="M271.221 489.471h-98.12v6.748h98.12v-6.748z" fill="#C7B4FD" />
      <path d="M271.223 489.471h-63.992v6.748h63.992v-6.748z" fill="#AB95F9" />
      <path d="M173.023 489.471h98.199" stroke="#8C7AE5" strokeWidth=".776" strokeMiterlimit="10" />
      <path
        d="M488.019 452.782v4.887H460.25v-4.887a4.7 4.7 0 014.732-4.731h18.227c2.715 0 4.81 2.171 4.81 4.731z"
        fill="#fff"
      />
      <path
        d="M488.019 457.669v33.508a4.701 4.701 0 01-4.731 4.732H465.06a4.701 4.701 0 01-4.732-4.732v-33.508h27.691z"
        fill="#7EDCF5"
      />
      <path
        d="M476.849 437.734v-1.008c0-.853-.699-1.551-1.552-1.551h-2.016c-.854 0-1.552.698-1.552 1.551v1.008a2.582 2.582 0 01-2.559 2.56h-.466a3.64 3.64 0 00-3.645 3.646v2.792h18.615v-2.792a3.641 3.641 0 00-3.645-3.646h-.466c-1.551 0-2.714-1.163-2.714-2.56z"
        fill="#00C0F3"
      />
      <g opacity=".8" fill="#fff">
        <path d="M468.472 476.981c.621-.232.698-.543.698-1.241v-1.706h-2.792v1.706c0 .698.078 1.009.698 1.164h-2.715c.621-.233.698-.543.698-1.164v-3.723c0-.698-.077-.931-.698-1.163h2.715c-.62.232-.698.465-.698 1.163v1.629h2.792v-1.629c0-.698-.077-.931-.698-1.163h2.715c-.62.232-.698.465-.698 1.163v3.723c0 .698.078 1.009.698 1.164h-2.715v.077zM471.886 476.983v-.233l1.861-2.327c.621-.776.854-1.396.854-2.094 0-.621-.543-1.241-1.164-1.241-.388 0-.853.155-1.008.387h.077c.543 0 .854.311.854.776a.696.696 0 01-.699.698c-.387 0-.775-.31-.775-.853 0-.698.853-1.551 2.172-1.551 1.008 0 1.939.62 1.939 1.629 0 1.085-1.396 1.784-2.405 3.025l-.543.698h3.025l-.155 1.086h-4.033zM480.418 477.06c-1.706 0-3.49-1.241-3.49-3.18s1.861-3.258 3.49-3.258c1.707 0 3.491 1.319 3.491 3.258.077 2.017-1.784 3.18-3.491 3.18zm2.094-3.18c0-1.629-.775-2.87-2.094-2.87-1.318 0-2.094 1.241-2.094 2.87s.776 2.87 2.094 2.87c1.319 0 2.094-1.241 2.094-2.87z" />
      </g>
    </g>
    <defs>
      <clipPath id="clipYugiTable">
        <path fill="#fff" transform="translate(0 .118)" d="M0 0h544.001v691.604H0z" />
      </clipPath>
    </defs>
  </svg>
);
